import React from 'react';
import about from '../../content/about.json';
import Markdown from '../../content/Markdown';

const pairs = (arr) => arr.reduce((rows, x, i) => {
  if (i % 2 === 0) rows.push([x]); else rows[rows.length - 1].push(x);
  return rows;
}, []);

const AboutUs = () => {
  return (
    <section name="about-us" id="about-us" className="scroll-to block spacer p-top-xl">
      <div className="wrapper">
        <div className="row gutter-width-sm">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div className="title">
              <h2>{about.title}</h2>
            </div>
          </div>
        </div>
        <div className="row gutter-width-sm">
          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div className="team-img team-img-mobile d-block d-md-none" style={ { backgroundImage: `url(${about.teamImageMobile})` } }>
            </div>
            <div className="team-img d-none d-md-block" style={ { backgroundImage: `url(${about.teamImage})` } }>
            </div>

            <Markdown className="team-text">{about.intro}</Markdown>
          </div>
        </div>

        <div className="row gutter-width-sm">
          {about.members.map((m, i) => (
            <div key={i} className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <div className="team-member">
                <div className="img object-fit">
                  <div className="object-fit-cover">
                    <img src={m.image} alt={m.name} />
                  </div>
                </div>

                <div className="team-member-content">
                  <div className="team-member-position">
                    <p>{m.position}</p>
                  </div>

                  <h4 className="team-member-t-head">{m.name}</h4>

                  <Markdown className="team-member-description">{m.text}</Markdown>
                </div>

                {(m.facebook || m.instagram) && (
                  <nav className="team-member-nav-items">
                    <ul className="nav">
                      {m.facebook && (
                        <li className="nav-item">
                          <a title="Facebook" href={m.facebook}><i className="fab fa-facebook-f"></i></a>
                        </li>
                      )}
                      {m.instagram && (
                        <li className="nav-item">
                          <a title="Instagram" href={m.instagram}><i className="fab fa-instagram"></i></a>
                        </li>
                      )}
                    </ul>
                  </nav>
                )}
              </div>
            </div>
          ))}
        </div>

        <hr />

        <div className="row gutter-width-sm">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div className="title">
              <h2 className="salon-headline">{about.salonTitle}</h2>
            </div>
          </div>
        </div>

        <div className="row gutter-width-sm">
          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <Markdown className="salon-text">{about.salonText}</Markdown>
          </div>
        </div>

        {pairs(about.salonImages).map((pair, r) => (
          <div key={r} className={`row gutter-width-sm salon-pics${r > 0 ? ' salon-pics-margin' : ''}`}>
            {pair.map((p, i) => (
              <div key={i} className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div className="salon-picture">
                  <img src={p.image} alt="Bild vom Salon" />
                </div>
              </div>
            ))}
          </div>
        ))}

      </div>
    </section>
  );
};

export default AboutUs;
